module.exports = __webpack_public_path__ + "img/0cc9421.jpg";